<template>
    <Head title="Welcome" />

    <div class="relative flex items-top justify-center min-h-screen bg-gray-100 dark:bg-gray-900 sm:items-center sm:pt-0">
        <div v-if="canLogin" class="hidden fixed top-0 right-0 px-6 py-4 sm:block">
            <Link v-if="$page.props.auth.user" :href="route('dashboard')" class="text-sm text-gray-700 underline">
                Dashboard
            </Link>

            <template v-else>
                <Link :href="route('login')" class="text-sm text-gray-700 underline">
                    Log in
                </Link>

                <Link v-if="canRegister" :href="route('register')" class="ml-4 text-sm text-gray-700 underline">
                    Register
                </Link>
            </template>
        </div>

        <div class="max-w-6xl mx-auto sm:px-6 lg:px-8">
            <div class="max-w-6xl mx-auto sm:px-6 lg:px-8">
                <div class="flex justify-center pt-8 sm:justify-start sm:pt-0">
                    <svg width="100%" height="100%" viewBox="0 0 57 11" version="1.1" xmlns="http://www.w3.org/2000/svg"
                         xml:space="preserve"
                         style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;">
                <g transform="matrix(1,0,0,1,-17.501,-44.896)">
                    <path
                        d="M18.352,52.196L17.501,52.552L17.501,47.034L22.605,44.896L22.605,45.962L18.352,47.744L18.352,52.196ZM26.008,47.448L20.904,49.587L20.904,55.104L26.008,52.966L26.008,47.448ZM20.053,49.02L24.307,47.238L24.307,46.172L19.202,48.31L19.202,53.828L20.053,53.472L20.053,49.02Z"
                        style="fill:rgb(39,56,130);fill-rule:nonzero;"/>
                    <g>
                        <path
                            d="M31.941,52.235C33.319,52.235 34.36,51.296 34.36,49.994C34.36,48.687 33.31,47.765 31.945,47.765C30.582,47.765 29.524,48.685 29.524,49.996C29.524,51.296 30.563,52.235 31.941,52.235ZM31.941,51.341C31.152,51.341 30.583,50.795 30.583,49.998C30.583,49.201 31.155,48.661 31.941,48.661C32.729,48.661 33.297,49.201 33.297,49.998C33.297,50.793 32.731,51.341 31.941,51.341Z"
                            style="fill:rgb(255,255,255);fill-rule:nonzero;"/>
                        <path
                            d="M35.099,52.173L36.136,52.173L36.136,50.643L36.713,50.643L37.698,52.173L38.937,52.173L37.777,50.501C38.356,50.281 38.705,49.82 38.705,49.226C38.705,48.4 38.032,47.827 36.929,47.827L35.099,47.827L35.099,52.173ZM36.136,49.779L36.136,48.687L36.835,48.687C37.319,48.687 37.649,48.873 37.649,49.237C37.649,49.586 37.347,49.779 36.835,49.779L36.136,49.779Z"
                            style="fill:rgb(255,255,255);fill-rule:nonzero;"/>
                        <path
                            d="M41.291,52.173C42.828,52.173 43.691,51.239 43.691,50C43.691,48.781 42.857,47.827 41.298,47.827L39.536,47.827L39.536,52.173L41.291,52.173ZM40.582,51.298L40.582,48.702L41.195,48.702C42.135,48.702 42.635,49.053 42.635,50.009C42.635,50.924 42.174,51.298 41.18,51.298L40.582,51.298Z"
                            style="fill:rgb(255,255,255);fill-rule:nonzero;"/>
                        <path
                            d="M44.443,52.173L47.708,52.173L47.708,51.3L45.487,51.3L45.487,50.416L47.37,50.416L47.37,49.548L45.487,49.548L45.487,48.7L47.657,48.7L47.657,47.827L44.443,47.827L44.443,52.173Z"
                            style="fill:rgb(255,255,255);fill-rule:nonzero;"/>
                        <path
                            d="M48.482,52.173L49.519,52.173L49.519,50.643L50.097,50.643L51.081,52.173L52.321,52.173L51.16,50.501C51.739,50.281 52.088,49.82 52.088,49.226C52.088,48.4 51.415,47.827 50.312,47.827L48.482,47.827L48.482,52.173ZM49.519,49.779L49.519,48.687L50.219,48.687C50.702,48.687 51.032,48.873 51.032,49.237C51.032,49.586 50.731,49.779 50.219,49.779L49.519,49.779Z"
                            style="fill:rgb(255,255,255);fill-rule:nonzero;"/>
                        <path
                            d="M53.035,50.909L52.574,51.598C53.044,51.952 53.673,52.235 54.46,52.235C55.452,52.235 56.268,51.787 56.268,50.857C56.268,49.226 53.757,49.848 53.757,49.07C53.757,48.796 54.063,48.64 54.517,48.64C54.892,48.64 55.332,48.742 55.737,48.971L56.191,48.301C55.735,47.977 55.115,47.765 54.466,47.765C53.495,47.765 52.716,48.235 52.716,49.13C52.716,50.72 55.199,50.144 55.199,50.917C55.199,51.172 54.935,51.335 54.425,51.335C53.941,51.335 53.491,51.193 53.035,50.909Z"
                            style="fill:rgb(255,255,255);fill-rule:nonzero;"/>
                        <path
                            d="M60.504,47.827L56.602,47.827L56.602,48.704L58.023,48.704L58.023,52.173L59.083,52.173L59.083,48.704L60.504,48.704L60.504,47.827Z"
                            style="fill:rgb(255,255,255);fill-rule:nonzero;"/>
                        <path
                            d="M63.774,52.173L64.916,52.173L63.144,47.827L61.94,47.827L60.191,52.173L61.277,52.173L61.633,51.226L63.412,51.226L63.774,52.173ZM61.938,50.394L62.516,48.869L63.101,50.394L61.938,50.394Z"
                            style="fill:rgb(255,255,255);fill-rule:nonzero;"/>
                        <path
                            d="M68.657,50.975C68.337,51.191 67.918,51.324 67.5,51.324C66.604,51.324 66.056,50.709 66.056,49.994C66.056,49.267 66.623,48.661 67.512,48.661C67.903,48.661 68.316,48.777 68.657,49.012L69.105,48.34C68.659,47.973 68.018,47.765 67.392,47.765C66.034,47.765 64.993,48.738 64.993,50.017C64.993,51.277 66,52.235 67.365,52.235C68.005,52.235 68.684,52.025 69.111,51.667L68.657,50.975Z"
                            style="fill:rgb(255,255,255);fill-rule:nonzero;"/>
                        <path
                            d="M71.001,50.33L72.608,52.173L73.91,52.173L71.879,49.846L73.683,47.827L72.447,47.827L71.011,49.424L70.778,49.424L70.778,47.827L69.722,47.827L69.722,52.173L70.778,52.173L70.778,50.33L71.001,50.33Z"
                            style="fill:rgb(255,255,255);fill-rule:nonzero;"/>
                    </g>
                </g>
            </svg>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .bg-gray-100 {
        background-color: #f7fafc;
        background-color: rgba(247, 250, 252, var(--tw-bg-opacity));
    }

    .border-gray-200 {
        border-color: #edf2f7;
        border-color: rgba(237, 242, 247, var(--tw-border-opacity));
    }

    .text-gray-400 {
        color: #cbd5e0;
        color: rgba(203, 213, 224, var(--tw-text-opacity));
    }

    .text-gray-500 {
        color: #a0aec0;
        color: rgba(160, 174, 192, var(--tw-text-opacity));
    }

    .text-gray-600 {
        color: #718096;
        color: rgba(113, 128, 150, var(--tw-text-opacity));
    }

    .text-gray-700 {
        color: #4a5568;
        color: rgba(74, 85, 104, var(--tw-text-opacity));
    }

    .text-gray-900 {
        color: #1a202c;
        color: rgba(26, 32, 44, var(--tw-text-opacity));
    }

    @media (prefers-color-scheme: dark) {
        .dark\:bg-gray-800 {
            background-color: #2d3748;
            background-color: rgba(45, 55, 72, var(--tw-bg-opacity));
        }

        .dark\:bg-gray-900 {
            background-color: #1a202c;
            background-color: rgba(26, 32, 44, var(--tw-bg-opacity));
        }

        .dark\:border-gray-700 {
            border-color: #4a5568;
            border-color: rgba(74, 85, 104, var(--tw-border-opacity));
        }

        .dark\:text-white {
            color: #fff;
            color: rgba(255, 255, 255, var(--tw-text-opacity));
        }

        .dark\:text-gray-400 {
            color: #cbd5e0;
            color: rgba(203, 213, 224, var(--tw-text-opacity));
        }
    }
</style>

<script>
    import { defineComponent } from 'vue'
    import { Head, Link } from '@inertiajs/vue3';

    export default defineComponent({
        components: {
            Head,
            Link,
        },

        props: {
            canLogin: Boolean,
            canRegister: Boolean,
            laravelVersion: String,
            phpVersion: String,
        }
    })
</script>
